module.exports = "pegasus/assets/circleline-facebook.png";